import axios from 'axios'

export default {
  state: {
    stations: [],
    filters: {},
    station: {}
  },
  mutations: {
    setStation(state, payload) {
      state.station = payload
    },
    setStations(state, payload) {
      state.stations = payload
    },
    setStationsFilters(state, payload) {
      state.filters = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    queryStations({state, dispatch, commit}) {
        let params = state.filters
        params.third_party = 0
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'stations', {params: params})
        .then(res => {
            console.log('queryStations', res.data.stations)
          commit('setStations', res.data.stations)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryStationsThirdParty({state, dispatch, commit}) {
      let params = state.filters
          params.third_party = 1
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'stations', {params: params})
        .then(res => {
            console.log('queryStationsThirdParty', res.data.stations)
          commit('setStations', res.data.stations)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeStation({dispatch, commit}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'stations', formData)
        .then(res => {
          formData.get('third_party') ? dispatch('queryStationsThirdParty') : dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateStation({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'stations/' + payload[0], payload[1])
        .then(res => {
          dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyStation({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'stations/' + payload.id)
        .then(res => {
          payload.third_party ? dispatch('queryStationsThirdParty') : dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },

    storePlatform({dispatch, commit}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'platforms', formData)
        .then(res => {
          formData.third_party ? dispatch('queryStationsThirdParty') : dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data.message})
          commit('setStation', res.data.station)
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updatePlatform({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'platforms/' + payload[0], payload[1])
        .then(res => {
            console.log(payload[2])
          payload[2] ? dispatch('queryStationsThirdParty') : dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data.message})
          commit('setStation', res.data.station)
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyPlatform({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'platforms/' + payload.id)
        .then(res => {
          payload.third_party ? dispatch('queryStationsThirdParty') : dispatch('queryStations')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getStations(state) {
      return state.stations
    },
    getStation(state) {
      return state.station
    }
  }
}